import React from 'react';

const About = () => {
    return (
        <div id="about">About page</div>
    );
}

export default About;
